import { render } from "./QuoteCard.vue?vue&type=template&id=1d4a9904&scoped=true"
import script from "./QuoteCard.vue?vue&type=script&lang=js"
export * from "./QuoteCard.vue?vue&type=script&lang=js"

import "./QuoteCard.vue?vue&type=style&index=0&id=1d4a9904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4a9904"]])

export default __exports__